const getLocation = () => new Promise((resolve, reject) =>  geoip2.city(resolve, reject));

UserLocations = {
    locations: null,
    locationIsDefined: false,
    get: function () {
        return this.locations
    },
    set: function(isoCode, countryName, cityName) {
        this.locations = {isoCode, countryName, cityName}
    },
    update: async function() {
        const locationsObject = this.getFromLS();
        if (locationsObject && locationsObject.isoCode && locationsObject.timestamp && locationsObject.countryName) {
            this.locationIsDefined = true;
            const date = locationsObject.timestamp;
            const now = new Date().getTime().toString();

            // Сheck if the day has passed after saving the isoCode
            if (date + 24 * 60 * 60 * 1000 < now) {
                await this.geo.get()
            } else {
                this.locations = {
                    isoCode: locationsObject.isoCode,
                    countryName: locationsObject.countryName,
                    cityName: locationsObject.cityName
                };
            }
        } else {
            await this.geo.get()
        }
    },
    getFromLS: function() {
        const location = localStorage.getItem("location");
        if (location) {
            return JSON.parse(location)
        } else {
            this.geo.get()
        }
    },
    saveToLS: function(isoCode, countryName, cityName) {
        localStorage.setItem("location", JSON.stringify(
            {isoCode, countryName, cityName, timestamp: new Date().getTime() }
        ));
    },
    geo: {
        get: async function() {
            if (typeof geoip2 !== 'undefined') {
                try{
                    const response = await getLocation()
                    const isoCode = response.country.iso_code
                    const countryName = response.country.names.ru
                    const cityName = response.city.names.ru

                    UserLocations.set(isoCode, countryName, cityName)
                    UserLocations.saveToLS(isoCode, countryName, cityName)
                    this.locationIsDefined = true;
                } catch (e) {
                }
            }
        },
    },
}